module.exports = __webpack_public_path__ + "img/Number=78.81dd92bf.png";